import { Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsFillExclamationTriangleFill } from "react-icons/bs";

interface DeleteConfirmationProps {
  show: boolean;
  dismiss: () => void;
  title?: string;
  description?: string;
  deleteText?: string;
  cancelText?: string;
  onDelete: () => void;
  isLoading?: boolean;
}

export const DeleteConfirmation = ({
  show,
  dismiss,
  title,
  description,
  onDelete,
  deleteText,
  cancelText,
  isLoading
}: DeleteConfirmationProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      contentClassName="tw-bg-white tw-rounded-2xl tw-shadow tw-flex-col tw-justify-start tw-items-center tw-inline-flex"
      show={show}
      onHide={dismiss}
      backdrop="static"
      centered
      size="sm"
    >
      <Modal.Body className="tw-flex tw-flex-col tw-gap-y-4">
        <div className="tw-self-stretch tw-pt-5 tw-pb-2 tw-flex-col tw-justify-start tw-items-center tw-gap-3 tw-flex">
          <div className="tw-w-10 tw-h-10 tw-p-2.5 tw-bg-amber-100 tw-rounded-3xl tw-justify-center tw-items-center tw-inline-flex">
            <div className="tw-w-5 tw-h-5 tw-relative tw-flex-col tw-justify-center tw-items-center tw-flex">
              <BsFillExclamationTriangleFill className="tw-text-amber-500" />
            </div>
          </div>
          <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-center tw-gap-2 tw-flex">
            <div className="tw-text-center tw-text-gray-700 tw-text-lg tw-font-semibold tw-font-['Lexend'] tw-leading-7">
              {title}
            </div>
            {description && (
              <div className="tw-text-center tw-text-gray-500 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
                {description}
              </div>
            )}
          </div>
        </div>
        <div className="tw-self-stretch tw-py-2 tw-flex-col tw-justify-start tw-items-start tw-gap-3 tw-flex">
          <button
            onClick={onDelete}
            className="tw-self-stretch tw-px-[17px] tw-py-[9px] tw-bg-red-600 tw-border-none tw-rounded-[99px] tw-shadow tw-justify-center tw-items-center tw-inline-flex tw-text-white tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal"
          >
            {isLoading ? (
              <Spinner size="sm" />
            ) : (
              deleteText || t("DeleteModal/key1")
            )}
          </button>
          <button
            onClick={dismiss}
            className="tw-self-stretch tw-px-[17px] tw-py-[9px] tw-bg-white tw-rounded-[99px] tw-shadow tw-border tw-border-solid tw-border-gray-300 tw-justify-center tw-items-center tw-inline-flex tw-text-gray-700 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal"
          >
            {cancelText || t("DeleteModal/key2")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
